// @flow

import {
    OPEN_DEFAULT,
    OPEN_VIDEO,
    OPEN_GALLERY,
    OPEN_MODEL,
    OPEN_RESOURCE,
    OPEN_STREAM,
    SET_SELECTED_TAB_NAME
} from './../types/modules';
import type { ModulesAction } from './../types/modules';

export const openDefault = (): ModulesAction => ({
    type: OPEN_DEFAULT,
});

export const openVideo = (): ModulesAction => ({
    type: OPEN_VIDEO
});

export const openGallery = (): ModulesAction => ({
    type: OPEN_GALLERY,
});

export const openResource = (): ModulesAction => ({
    type: OPEN_RESOURCE,
});

export const openModel = (): ModulesAction => ({
    type: OPEN_MODEL,
});

export const openStream = (): ModulesAction => ({
    type: OPEN_STREAM,
});

export const setSelectedTabNameAction = (selectedTabName: string) => ({
    type: SET_SELECTED_TAB_NAME,
    selectedTabName
});



// WEBPACK FOOTER //
// ./src/actions/modules.jsx